import Joi from 'joi';

export const LoginPayloadSchema = Joi.object({
  email: Joi.string(),
  password: Joi.string(),
  recaptchaToken: Joi.string(),
  productFamily: Joi.string(),
});

export const LoginByEmailPayloadSchema = Joi.object({
  email: Joi.string(),
  recaptchaToken: Joi.string(),
  productFamily: Joi.string(),
});

export const LoginResponseSchema = Joi.object({
  access_token: Joi.string(),
  message_en: Joi.string(),
  template: Joi.string(),
  id: Joi.number(),
  redirect_url: Joi.string(),
});

export const SocialLoginPayloadSchema = Joi.object({
  type: Joi.string().required(),
  data: Joi.object({
    token: Joi.string(),
    userId: Joi.string(),
  }),
  productFamily: Joi.string(),
  recaptchaToken: Joi.string(),
});

export const SocialLoginResponseSchema = Joi.object({
  url: Joi.string(),
  message_en: Joi.string(),
  existingUser: Joi.boolean(),
  id: Joi.number(),
  access_token: Joi.string(),
});
